// extracted by mini-css-extract-plugin
module.exports = {"close":"close--Jy3Xf","section":"section--2ofem","container":"container--22fR3","mobile":"mobile--3zZpj"};